<div class="main">
  <div class="row address-container heading-text m-0">
    <div class="col-md-3 pl-0">
      <label>{{ "quoteReview.soldAddress" | cxTranslate }}</label>
    </div>
    <div class="col-md-3">
      <label>{{ "quoteReview.shipAddress" | cxTranslate }}</label>
    </div>
    <div class="col-md-3">
      <label>{{ "quoteReview.customerAddress" | cxTranslate }}</label>
    </div>
  </div>

  <div class="row address-container m-0">
    <div class="col-md-3 pl-0">
      <div>
        <address *ngIf="soldToAddress">
          <div>{{soldToAddress?.firstName}}{{soldToAddress?.firstName ? ',': ''}} {{soldToAddress?.lastName}}{{soldToAddress?.lastName ? ',': ''}}</div>
          <div>{{soldToAddress?.companyName}}{{soldToAddress?.companyName? ',': ''}}</div>
          <div>{{soldToAddress?.line1}}{{soldToAddress?.line1? ',': ''}} {{soldToAddress?.line2}}{{soldToAddress?.line2? ',': ''}}</div>
          <div>{{soldToAddress?.town}}{{soldToAddress?.town? ',': ''}} </div>
          <div>{{soldToAddress?.region?.name }}{{soldToAddress?.region?.name? ',': '' }}</div>
          <div>{{soldToAddress?.country?.name }}{{soldToAddress?.country?.name? ',': '' }} </div>
          <div>{{soldToAddress?.postalCode}} </div>
        </address>
      </div>
    </div>
    <div class="col-md-3">
      <div class="align-right">
        <address *ngIf="shipToAddress">
          <!-- <span class="name"> {{shipToAddress?.firstName}}  {{shipToAddress?.lastName}}</span><br> -->
          <div>{{shipToAddress?.companyName}}{{shipToAddress?.companyName?',':''}}</div>
          <div>{{shipToAddress?.line1}}{{shipToAddress?.line1?',': ''}} {{shipToAddress?.line2}}{{shipToAddress?.line2? ',':''}}</div>
          <div>{{shipToAddress?.town}}{{shipToAddress?.town? ',':''}}</div>
          <div>{{shipToAddress?.region?.name }}{{shipToAddress?.region?.name?',':'' }}</div>
          <div>{{shipToAddress?.country?.name }}{{shipToAddress?.country?.name?',':'' }}</div>
          <div>{{shipToAddress?.postalCode}}</div>
        </address>
      </div>
    </div>
    <div class="col-md-3">
      <div>
        <address *ngIf="endUserAddress">
          <div>{{endUserAddress?.firstName}}</div>
          <div>{{endUserAddress?.companyName}}{{endUserAddress?.companyName ? ",":''}}</div>
          <div>{{endUserAddress?.line1}}{{endUserAddress?.line1?',':''}} {{endUserAddress?.line2}}{{endUserAddress?.line2?',':''}}</div>
          <div>{{endUserAddress?.town}}{{endUserAddress?.town?',':''}}</div>
          <div>{{endUserAddress?.region?.name}}{{endUserAddress?.region?.name?',':''}}</div>
          <div>{{endUserAddress?.country?.name}}{{endUserAddress?.country?.name?',':''}}</div>
          <div>{{endUserAddress?.postalCode}} </div>
        </address>
      </div>
    </div>
  </div>
</div>